import { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNotify, useRecordContext, useRefresh } from "react-admin";
import { IfCanAccess } from "@react-admin/ra-rbac";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import { BASE_API_URL } from "../../../config/configUrl";
import { getAccessToken } from "../../../admin/authProvider";

const postValidateStatement = (id: string | number) =>
  fetch(`${BASE_API_URL}/gasstation/statements/${id}/validate`, {
    method: "POST",
    credentials: "include",
    headers: new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${getAccessToken()}`,
    }),
  }).then(async (response) => {
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || response.statusText);
    }
    return response.json();
  });

function ValidateAction() {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  if (!record || record.status !== "DRAFT") return null;

  const handleValidate = async () => {
    setLoading(true);
    try {
      await postValidateStatement(record.id);
      notify(t("Statement validated"), { type: "success" });
      refresh();
    } catch (error: any) {
      notify(`${t("Action failed")}: ${error.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <IfCanAccess action="validate" resource="gasStationStatements">
      <Button
        variant="contained"
        color="success"
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <DoneRoundedIcon />}
        disabled={loading}
        onClick={handleValidate}
      >
        {t("Validate")}
      </Button>
    </IfCanAccess>
  );
}

export default ValidateAction;
